import { render } from "./TrasladobodegaView.vue?vue&type=template&id=96d99116"
import script from "./TrasladobodegaView.vue?vue&type=script&lang=js"
export * from "./TrasladobodegaView.vue?vue&type=script&lang=js"

import "./TrasladobodegaView.vue?vue&type=style&index=0&id=96d99116&lang=css"

import exportComponent from "D:\\gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__